import { Icon } from 'core-ui';
import { Svg } from 'src/assets/icons/ListOwnerIcon/svg';
import { CustomIconComponentProps } from 'src/models/icon';

export const ListOwnerIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
);
